<template>
	<div class="w-100 d-block mb-4" :style="{'height': `${height}px`}">
	</div>
</template>
<script>
	export default{
		props:{
			height:{
				type: Number,
				default: 50
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/blockHeight.vue